import { isPayInfull as isPayInFullFn, isPayManual as isPayManualFn } from './commonUtils.js';

const setPayManualAndPayInfullState = (state, action) => {
  const paymentPlanOptions = action.payload;
  const {
    currentPaymentOptionType,
  } = state;
  if (currentPaymentOptionType === 'PAY_DEPOSIT_WITH_PAYMENT_PLAN' && !!paymentPlanOptions) {
    state.isPayInfull = isPayInFullFn(paymentPlanOptions);
    state.isPayManual = isPayManualFn(paymentPlanOptions);
  } else {
    state.isPayInfull = false;
    state.isPayManual = false;
  }
};

export default setPayManualAndPayInfullState;
